
import React from "react";
import SituationImage from "../situation/SituationImage";

interface AboutMeIntroProps {
  imageUrl: string;
  isMobile: boolean;
  section?: string;
}

const AboutMeIntro = ({ imageUrl, isMobile, section = "about-me-banner" }: AboutMeIntroProps) => {
  return (
    <>
      {isMobile ? (
        <div className="flex flex-col md:flex-row md:items-center md:space-x-8">
          <SituationImage 
            imageUrl={imageUrl} 
            isMobile={true} 
            section={section}
          />
          <div className="w-full md:w-1/2">
            <div className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20">
              <p className="text-white text-left text-base md:text-lg">
                Wahrscheinlich kennen wir uns noch nicht. Damit du mit mir aber nicht die berühmte "Katze im Sack" kaufst, möchte mich dir noch ein wenig vorstellen und dir ein kleines bisschen zeigen, wer ich bin.
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-col items-center">
          <SituationImage 
            imageUrl={imageUrl} 
            isMobile={false} 
            section={section}
          />
          <div className="w-full max-w-4xl mb-8">
            <div className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20">
              <p className="text-white text-left text-base md:text-lg">
                Wahrscheinlich kennen wir uns noch nicht. Damit du mit mir aber nicht die berühmte "Katze im Sack" kaufst, möchte mich dir noch ein wenig vorstellen und dir ein kleines bisschen zeigen, wer ich bin.
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AboutMeIntro;
